import "proxy-polyfill";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/components/GlobalCss/globalStyle.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "react-phone-input-2/lib/style.css";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { OpenAPI } from "@propertelligent/client-api";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { MyProvider } from "./utils/context/LoginContext";
import { PermissionProvider } from "./utils/context/PermissionContext";
import { PropertyProvider } from "./utils/context/PropertyProvider";
import { MenuProvider } from "./utils/context/MenuContext";
import { ThemeProvider } from "./utils/context/ThemeContext";
import store from "./store";
import { QuickstartProvider } from "./components/firstTimeUserExperience/Context";
import { ErrorProvider } from "./utils/context/ErrorContext";
import { OverviewProvider } from "./utils/context/OverviewContext";
import { GeneratePdfProvider } from "./utils/context/GeneratePdfContext";
import { PaymentProvider } from "./utils/context/PaymentContext";
import { OnboardingProvider } from "./utils/context/OnboardingContext";
import {
  NotificationPayload,
  NotificationType,
  PubSub,
  TopicsEnum,
} from "./utils/pubsub";

const root = ReactDOM.createRoot(document.getElementById("root")!);

if (!window.location.href.includes("localhost")) {
  OpenAPI.BASE = "";
}

function handleClickOutside(event: MouseEvent) {
  PubSub.publish(TopicsEnum.BodyMouseDown.toString(), {
    type: NotificationType.BodyMouseDown,
    message: "",
    event, // <- Pass the actual event
  } as any); // Use `as any` if TypeScript complains
}

document.addEventListener("mousedown", handleClickOutside);

root.render(
  <ErrorProvider>
    <ThemeProvider>
      <MyProvider>
        <PermissionProvider>
          <PaymentProvider>
            <GeneratePdfProvider>
              <OverviewProvider>
                <OnboardingProvider>
                  <Provider store={store}>
                    <PropertyProvider>
                      <QuickstartProvider>
                        <MenuProvider>
                          <BrowserRouter>
                            <App />
                          </BrowserRouter>
                        </MenuProvider>
                      </QuickstartProvider>
                    </PropertyProvider>
                  </Provider>
                </OnboardingProvider>
              </OverviewProvider>
            </GeneratePdfProvider>
          </PaymentProvider>
        </PermissionProvider>
      </MyProvider>
    </ThemeProvider>
  </ErrorProvider>,
);
